var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list list-style-none"},_vm._l((_vm.children),function(item,index){return _c('li',{key:index},[_c(_vm.childComponent,_vm._b({tag:"component"},"component",_vm._d({},[_vm.bindToProp,item])))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }